import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@components/header'
import { columnItemsAdmin } from '@utils/columns'
import { getToday } from '@utils/time'
import Layout from '@components/Layout'
import CreteItemAdminModal from '@components/Modal/createItemAdminModal'
import { useQuery } from '@tanstack/react-query'
import { debouncedSet } from '@utils/debounce'
import { http } from '@services/http'
import EditItemsModal from '@components/Modal/editItemsModal'
import { fetchItemsGroups, fetchItemsOnly } from '@utils/fetchData'

const ItemsAdmin = () => {
	const { t } = useTranslation()
	const formattedDate = getToday()

	const [isModalVisible, setIsModalVisible] = useState(false)
	const [isViewModalVisible, setIsViewModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)
	const [selectedViewRowData, setSelectedViewRowData] = useState(null)
	const [currentPage, setCurrentPage] = useState(0)
	const [itemName, setItemName] = useState('')
	const [itemCode, setItemCode] = useState('')
	const [category, setCategory] = useState('')
	const [itemType, setItemType] = useState('')
	const [pageSize] = useState('10')

	const {
		data = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ['itemsAdmin', itemName, category, currentPage, pageSize],
		queryFn: fetchItemsOnly,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const handleNextPage = () => {
		if (data.length === 10) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleRowClick = (record) => {
		setSelectedRowData(record)
		setIsModalVisible(true)
	}
	const handleViewRowClick = (record) => {
		setSelectedViewRowData(record)
		setIsViewModalVisible(true)
	}

	const handleCategoryChange = (val) => {
		debouncedSet(val, setCategory)
	}

	const { data: itemsGroupData = [], isLoading: itemsLoading } = useQuery({
		queryKey: ['itemsGrp'],
		queryFn: fetchItemsGroups,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const handleItemNameChange = (val) => {
		debouncedSet(val, setItemName)
	}

	const columns = columnItemsAdmin(
		t,
		handleViewRowClick,
		handleItemNameChange,
		handleCategoryChange,
		itemsGroupData,
	)

	return (
		<Layout>
			<Header
				title={'items'}
				currentPage={currentPage + 1}
				handlePreviousPage={handlePreviousPage}
				handleNextPage={handleNextPage}
				hasMoreData={data.length === 10}
				columns={columns}
				fdata={data}
				loading={isLoading}
				onBtnClick={handleRowClick}
				formattedDate={formattedDate}
				isSticky={false}
			/>
			<CreteItemAdminModal
				visible={isModalVisible}
				data={selectedRowData}
				onClose={() => {
					setIsModalVisible(false)
					setCurrentPage(0)
					refetch()
				}}
			/>
			<EditItemsModal
				visible={isViewModalVisible}
				data={selectedViewRowData}
				onClose={() => {
					setIsViewModalVisible(false)
					refetch()
				}}
			/>
		</Layout>
	)
}

export default ItemsAdmin
